export const environment = {
  environment: 'prod',
  msClientId: 'e31a03fc-5d4e-4c70-8a76-bf0fcb3abbf3',
  msAuthority: 'https://login.microsoftonline.com/e5d3ae7c-9b38-48de-a087-f6734a287574',
  msApiScope: 'api://7d532933-59a7-4f6c-882c-5b11168bce88/access_as_user',
  msRedirectUri: 'https://sgtp.infraestrutura.mg.gov.br/',
  baseApiPath: 'https://sgtp.infraestrutura.mg.gov.br',
};
